module.exports = __webpack_public_path__ + "media/components/footer/static/icon__facebook-374fd3c3fc56bf85e24b14fd7e73c47b.svg";